import {
    TOURPRODUCT_LOADING, GET_TOURPRODUCT_DATA_SUCCESS,
    GET_TOURPRODUCT_DATA_ERROR
} from "../actions/actionTourProduct";

import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "TourProducts";

const initialState = {
    tourProduct: {},
    loading: false,
    tourProductError: ''
};

function reducerTourProduct(state = initialState, action) {

    switch (action.type) {
        case TOURPRODUCT_LOADING: {
            return {
                ...state,
                loading: true,
                tourProductError: ''
            };
        }

        case GET_TOURPRODUCT_DATA_SUCCESS: {

            return {
                ...state,
                loading: false,
                tourProduct: action.payload,
                tourProductError: ''
            };
        }

        case GET_TOURPRODUCT_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                tourProduct: action.payload,
                tourProductError: action.error
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerTourProduct;